var _excluded = ["className", "children", "requiredIndicator"],
  _excluded2 = ["children", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import * as React from 'react';
import { forwardRef, omitThemingProps, tqc, useStyleConfig, useStyles } from '../../system';
import { cx, dataAttr } from '../../utils';
import { useFormControlContext } from './FormControl';
export function useFieldLabel(props) {
  var _props$id, _props$htmlFor;
  var field = useFormControlContext();
  return _objectSpread(_objectSpread({}, props), {}, {
    'data-focus': dataAttr(field === null || field === void 0 ? void 0 : field.isFocused),
    'data-disabled': dataAttr(field === null || field === void 0 ? void 0 : field.isDisabled),
    'data-invalid': dataAttr(field === null || field === void 0 ? void 0 : field.isInvalid),
    'data-readonly': dataAttr(field === null || field === void 0 ? void 0 : field.isReadOnly),
    id: (_props$id = props.id) !== null && _props$id !== void 0 ? _props$id : field === null || field === void 0 ? void 0 : field.labelId,
    htmlFor: (_props$htmlFor = props.htmlFor) !== null && _props$htmlFor !== void 0 ? _props$htmlFor : field === null || field === void 0 ? void 0 : field.id
  });
}
/**
 * Used to enhance the usability of form controls.
 *
 * It is used to inform users as to what information
 * is requested for a form field.
 *
 * Every form field should have a form label.
 */
export var FormLabel = forwardRef((passedProps, ref) => {
  var styles = useStyleConfig('FormLabel', passedProps);
  var props = omitThemingProps(passedProps);
  var {
      className,
      children,
      requiredIndicator = /*#__PURE__*/React.createElement(RequiredIndicator, null)
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var ownProps = useFieldLabel(rest);
  var field = useFormControlContext();
  return /*#__PURE__*/React.createElement(tqc.label, _extends({
    ref: ref,
    className: cx('tqc-form__label', className),
    __css: _objectSpread({
      display: 'block',
      textAlign: 'start',
      fontWeight: 600
    }, styles)
  }, ownProps), children, " ", field !== null && field !== void 0 && field.isRequired ? requiredIndicator : null);
});
FormLabel.displayName = 'FormLabel';
/**
 * Used to show a "required" text or an asterisks (*) to indicate that
 * a field is required.
 */
export var RequiredIndicator = forwardRef((props, ref) => {
  var {
      children,
      className
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  var field = useFormControlContext();
  var styles = useStyles();
  if (!(field !== null && field !== void 0 && field.isRequired)) return null;
  var _className = cx('tqc-form__required-indicator', className);
  return /*#__PURE__*/React.createElement(tqc.span, _extends({
    ref: ref
  }, rest, {
    __css: styles.requiredIndicator,
    className: _className
  }), children || /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(tqc.span, {
    srOnly: true
  }, " - "), /*#__PURE__*/React.createElement(tqc.span, {
    role: "presentation",
    "aria-hidden": true
  }, " * "), /*#__PURE__*/React.createElement(tqc.span, {
    __css: styles.requiredText
  }, "Required")));
});
RequiredIndicator.displayName = 'RequiredIndicator';